import { DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonComponent } from '@shared/components/btn/button.component';
import { faClose } from '@fortawesome/free-solid-svg-icons';

@Component({
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, ButtonComponent],
  selector: 'esp-modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.scss']
})
export class ModalAlertComponent implements OnInit {
  mensaje: string = "";
  title: string = "";
  faClose = faClose
  constructor(@Inject(MAT_DIALOG_DATA) public data: ModalAlertComponent,
  private _dialogRef                    : DialogRef<any>
) {
  if(data){ 
    this.title = data.title || "Advertencia"
    this.mensaje = data.mensaje || "Advertencia"
  }
  else{
    this.title = "Advertencia"
    this.mensaje = "Advertencia"
  }
}

  onClose(){
    this._dialogRef.close();
    }

   ngOnInit(){

   }
}
